import React from 'react'

import {connect} from 'react-redux'

import MainPaper from '../../component/MainPaper'
import EndButtons from "../../component/EndButtons";
import NotSuccessfulPaymentSummary from "../../component/NotSuccessfulPaymentSummary";
import PaymentResult from "../../component/PaymentResult";
import Main from "../Main";

/**
 * The portion showing the erroneous outcome of a failed Offline Payment.
 *
 * @param resultData : {Object} The data explaining the error.
 * @param formData: {Object} Data from the original form.
 */
const NotSuccessfulPayment = ({resultData, formData}) =>
    <MainPaper after={<EndButtons successUrl={formData.successUrl}/>}>
        <PaymentResult success={resultData.success} subtitle={"No se ha podido generar el comprobante"}/>
        <NotSuccessfulPaymentSummary resultData={resultData} error={resultData.error}/>
    </MainPaper>

const mapStateToProps = state => ({
    resultData: state.forms.resultData,
    formData: state.forms.formData
})

const DataBound = connect(mapStateToProps)(NotSuccessfulPayment)

export default Main(DataBound)
